module.exports = "/images/vendor/flag-icon-css/flags/1x1/mr.svg?bf379763ac177c83487cb02586e19651";